import React, { useEffect, useState } from 'react'
import Dropdown from '../../../DropDown/Dropdown'
import ReportsUploader from '../../../ReportsUploader/ReportsUploader'
import './choosedoctor.css'
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory, useRouteMatch } from "react-router-dom";
import moment from 'moment'
import {
    fetch_clinic_speciality,
    fetch_clinic_speciality_doctor_list,
    insert_inter_branch,
    fetch_patients_details,
    Store_formData,
    book_appointment,
    show_common_alert, book_Videoconsultaton,
    fetch_consultationNow,
    show_common_confirm

} from "../../../../actions/InterBranchCoordinatorAction"
import { fetch_appointmentSlot } from "../../../../actions/AppointmentSlotAction";
import { DatePicker, Form, TimePicker, Modal } from 'antd';
import { fetchTypeofAppoinment } from "../../../../actions/ReasonforVisitAction";
// Coupon UI imports removed
import { convertDateToString } from '../../../../Helpers/dateFunctions';
import { INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM, INTERBRANCH_MODAL_UPDATE, INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM, INTERBRANCH_UPLOAD_REPORTS_UPDATE } from '../../../../actions/type';

function ChooseDoctor({ setIsAllActive }) {

    let history = useHistory()
    let dispatch = useDispatch()
    let clinicId = useSelector((state) => state?.login?.user?.clinicId);
    let partnerId = useSelector((state) => state?.login?.user?.userId);
    let { path, url } = useRouteMatch();


    //We van controle the form using form this useForm hook.  "form" this is the instance name.
    const [form] = Form.useForm();

    let reduxData = useSelector(state => state);
    console.log("Redux data in Choose Dr:", reduxData)
    let specialities = reduxData?.interBranchCoordinator?.interBranchClinicSpeciality?.data;

    let specialityDoctors = reduxData?.interBranchCoordinator?.interBranchClinicSpecialityDoctorList?.data;

    let patientId = localStorage.getItem("PatientId");

    let typeOfConsultation = reduxData?.bookAppoinment?.typeofAppoinment;

    let appointmentBookStatus = reduxData?.interBranchCoordinator?.interBranchAppointmentBookStatus

    const localReportsUploaded = useSelector((state) => state?.interBranchCoordinator?.temp_appointment_form?.reportsUploaded)

    let userDetails = JSON.parse(localStorage.getItem("userData"));
    const userId = userDetails.profileId;

    let appointment_form = useSelector(state => state?.interBranchCoordinator?.appointment_form)
    let temp_appointment_form = useSelector(state => state?.interBranchCoordinator?.temp_appointment_form)

    let typeOfConsultationBooked = reduxData?.interBranchCoordinator?.appointment_form?.typeOfConsultation;
    let patientNumber = reduxData?.interBranchCoordinator?.appointment_form?.patientNumber?.numberWithCode;
    let { specialisation, chosendoctorId, patientHospitalId, chosenDate } = reduxData?.interBranchCoordinator?.appointment_form;

    let { timeSlot } = useSelector(state => state?.doctorDetail)

    const [chosenSpeciality, setChosenSpeciality] = useState(null);
    const [chosenDoctorId, setChosenDoctorId] = useState(chosendoctorId);
    const [chosenTypeOfConsultation, setChosenTypeOfConsultation] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);

    const [buttonClicked, setButtonClicked] = useState(null);
    let [isFilled, setFilled] = useState(false);
    let [isDrLoading, setDrLoading] = useState(false)
    const [selecteddate, setSelectedDate] = useState("")
    const [enableAllTabs, setEnableAllTabs] = useState(false);
    
    
    useEffect(() => {
        console.log('enableAllTabs changed to:', enableAllTabs);
    }, [enableAllTabs]);
   
    let [doctorsList, setDoctorsList] = useState([])
    let [consultationId, setconsultationId] = useState("")
     let [resumevisible, setResumevisible] = useState(false)
    const [consultationPopupVisible, setConsultationPopupVisible] = useState(false);
    const [consultationData, setConsultationData] = useState(null);
    const MINUTE_MS = 10000;

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Add global click handler to enable tabs when any button is clicked
    useEffect(() => {
        const handleGlobalClick = (event) => {
            if (event.target.tagName === 'BUTTON' || 
                event.target.closest('.button-container') || 
                event.target.closest('.submt-btn') || 
                event.target.closest('.join-btn')) {
                setEnableAllTabs(true);
            }
        };

        document.addEventListener('click', handleGlobalClick);
        return () => {
            document.removeEventListener('click', handleGlobalClick);
        };
    }, []);

    useEffect(() => {

        try {
            dispatch(fetch_clinic_speciality(clinicId)).then(() => {

                loadDefaultValues()

            });


        } catch (error) {
            
        }
        loadReportsUploadedToLocalForm()

        return () => {
            dispatch({
                type: INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM,
            })
        }
    }, [])


    useEffect(() => {
        setDrLoading(true)
        try {
            if (chosenSpeciality) {
                //Reset field value by assigning undefined or change value by giving direct value to "doctorId (Form item name)" 


                form.setFieldsValue({ doctorId: undefined });
                form.setFieldsValue({ typeOfConsultation: undefined });
                form.setFieldsValue({ time: undefined });
                form.setFieldsValue({ date: "" });

                dispatch(fetch_clinic_speciality_doctor_list(clinicId, chosenSpeciality)).then((res) => {
                    console.log("Response",res)
                     setDoctorsList(res?.data)
                    setDrLoading(false)
                    if (appointment_form.chosendoctorId && chosenSpeciality == appointment_form.specialisation) {
                        form.setFieldsValue({ doctorId: appointment_form.chosendoctorId });
                    }
                    if (appointment_form.typeOfConsultation && chosenSpeciality == appointment_form.specialisation) {
                        form.setFieldsValue({ typeOfConsultation: appointment_form.typeOfConsultation });
                    }
                    if (appointment_form.typeOfConsultation && appointment_form.chosendoctorId && chosenSpeciality == appointment_form.specialisation) {
                        form.setFieldsValue({ date: appointment_form.chosenDate });
                        form.setFieldsValue({ time: appointment_form.chosenTime });
                    }
                })
            }
            else {
                setDrLoading(false)
            }



        } catch (error) {
            setDrLoading(false)
            
        }
    }, [chosenSpeciality])

    useEffect(() => {
        try {
            if (chosenDoctorId) {
                //Reset Type of consultation if Doctor id changes            
                form.setFieldsValue({ typeOfConsultation: undefined });
                // form.setFieldsValue({ date: moment(new Date()) });
                form.setFieldsValue({ date: "" });
                form.setFieldsValue({ time: undefined });
            }
            dispatch(fetchTypeofAppoinment(chosenDoctorId))
        } catch (error) {
            
        }


    }, [chosenDoctorId])


    useEffect(() => {
        if (chosenTypeOfConsultation) {
            form.setFieldsValue({ date: "" });
            form.setFieldsValue({ time: undefined });
        }

        if (selecteddate) {
            getTimeSlots(selecteddate)
        }

        // getTimeSlots(moment(new Date()))
    }, [chosenTypeOfConsultation])

    useEffect(() => {
        if (selecteddate) {
            form.setFieldsValue({ time: undefined });
        }
        getTimeSlots(selecteddate)
    }, [selecteddate])

    

    useEffect(() => {
        setChosenSpeciality(appointment_form?.specialisation)
        setChosenDoctorId(appointment_form?.chosendoctorId)
        setChosenTypeOfConsultation(typeOfConsultationBooked)
        setSelectedDate(appointment_form?.chosenDate)
        setSelectedTime(appointment_form?.chosenTime)

    }, [appointment_form])

    useEffect(() => {

       
        const interval = setInterval(() => {
            consultationnow()
        }, MINUTE_MS);

        return () => clearInterval(interval);

    })

    function consultationnow() {
        //findConsultationForNow
        try {
            dispatch(fetch_consultationNow(userId)).then((data) => {


                if (data.data.appointmentId != undefined) {
                    setResumevisible(true)
                    setconsultationId(data.data.appointmentId);
                    
                    // Set consultation data for popup
                    setConsultationData({
                        appointmentId: data.data.appointmentId,
                        patientName: data.data.patientName || "Patient",
                        doctorName: data.data.doctorName || "Doctor",
                        patientAge: data.data.patientAge || "",
                        patientGender: data.data.patientGender || ""
                    });
                    
                    // Show consultation popup
                  

                }
                else {

                    setResumevisible(false)
                    setConsultationPopupVisible(false);
                    setConsultationData(null);
                }

            });
        } catch (error) {
            console.log("Error in fetch_clinic_speciality API", error);
        }
    }
    

    let convertSpecialitiesForDropDown = (specility_list) => {



        let result = []

        if (specility_list && specility_list.length > 0) {
            specility_list.map((element, key) => { result.push({ option: element.specialityName, value: element.specialityUrl }) })

        }
        return result;

    }

    let convertDoctorNamesForDropDown = (doctor_list) => {

        console.log("doctor_list",doctor_list)
        let dropdownOptions = []

        if (doctor_list && doctor_list.length > 0) {
            doctor_list
                .filter((eachItem) => {
                    // In schedule mode, show all doctors without checking login status
                    if (isScheduled()) {
                        return true;
                    }
                    // In non-schedule mode, only show active doctors
                    let status = (eachItem?.loginstatus || "").toString().toLowerCase();
                    return status === "active";
                })
                .map((eachItem) => {
                    let id = Object.keys(eachItem)[0]
                    let name = Object.values(eachItem)[0]
                    dropdownOptions.push({ option: name, value: id, status: eachItem.loginstatus })
                })
        }
        console.log("dropdownOptions",dropdownOptions)

        return dropdownOptions;
    }

    let convertTypeOfConsultationForDropDown = (type_list) => {
        let result = [];
        if (type_list && type_list.length > 0) {
            type_list.map((element, key) => { result.push({ option: element.Type, value: element.Type }) })
        }
        return result;

    }

    let convertTimesForDropDown = (timesList) => {

        let indexdate = moment(selecteddate).format("D-M-YYYY")

        let filterList = timesList.filter((each) => each.date == indexdate)[0]

        console.log(indexdate, filterList);

        let result = [];
        if (filterList && filterList.slots && filterList.slots.length > 0) {
            filterList.slots.map((element, key) => { result.push({ option: element.time, value: element.time }) })
        }
        return result;

    }

    let getTimeSlots = (e) => {

        setSelectedDate(e)
        console.log("date e._d:", e._d, "selecteddate:", selecteddate)
        dispatch(fetch_appointmentSlot({
            isStart: true,
            isNext: false,
            date: e._d,//selecteddate,
            typeofconsultation: chosenTypeOfConsultation,
            doctorId: chosenDoctorId
        }
        ))
            .then((res) => {
                console.log("Slots: ", res)
            })
    }

    const onFinish = (values) => {


        let submissiondata = {
            specialisation: values?.specialisation,
            chosendoctorId: values?.doctorId,
            typeOfConsultation: values?.typeOfConsultation,
            reportsUploaded: localReportsUploaded ? localReportsUploaded : []
        }



        if (url.includes("scheduleappointment")) {
            submissiondata['chosenDate'] = values?.date
            submissiondata['chosenTime'] = values?.time
        }


        dispatch(
            Store_formData({
                ...submissiondata
            })
        )

        try {
            dispatch(fetch_patients_details(chosendoctorId, patientId, appointment_form, submissiondata)).then((res) => {
                console.log("Fetched patient details", res)
            })
        } catch (error) {
            
        }

        if (buttonClicked === "Review") {
            // try {
            //     dispatch(fetch_patients_details(chosendoctorId, patientId, appointment_form, submissiondata)).then((res) => {

            history.push(`/dashboard/${url.includes("bookandconsult") ? "bookandconsult" : "scheduleappointment"}/patientmedical`)

            dispatch({
                type: INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM,
            })
            //     })
            // } catch (error) {
            
            // }

        }
        if (buttonClicked === "Join") {

            
                try {
                    try {
                    dispatch(book_Videoconsultaton(patientId, userId, chosenDoctorId, chosenTypeOfConsultation, null,  temp_appointment_form)).
                        then((res) => {

                            if (res.data.appointmentId != "Time slot already choosen by some other person. Please try with different slot, Sorry for the inconvenience.") {

                                localStorage.setItem("AppointmentId", res.data.appointmentId)
                                history.push("/meetspoke/"+res.data.appointmentId);
                                // history.push("/meetdr/"+res.data.appointmentId);
                                dispatch({
                                    type: INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM,
                                })
                            }

                        })
                } catch (error) {
                    
                }
            } catch (error) {

            }

        }



    };


    const onFinishFailed = (errorInfo) => {
        
    };


    

    // button visibility will be based on mandatory fields

    const areMandatoryFieldsFilled = () => {
        // If enableAllTabs is true, always return true to enable all tabs
        if (enableAllTabs) {
            console.log('areMandatoryFieldsFilled: enableAllTabs is true, returning true');
            return true;
        }
        
        const spec = form.getFieldValue('specialisation');
        const doc = form.getFieldValue('doctorId');
        const toc = form.getFieldValue('typeOfConsultation');
        if (isScheduled()) {
            const date = form.getFieldValue('date');
            const time = form.getFieldValue('time');
            const result = Boolean(spec && doc && toc && date && time);
            console.log('areMandatoryFieldsFilled (scheduled):', result, {spec, doc, toc, date, time});
            return result;
        }
        const result = Boolean(spec && doc && toc);
        console.log('areMandatoryFieldsFilled (not scheduled):', result, {spec, doc, toc});
        return result;
    }

    let isScheduled = () => {

        return url.includes("scheduleappointment")

    }

    let handleSubmit = () => {
        // Enable all tabs when any button is clicked
        setEnableAllTabs(true);
        setButtonClicked("Review")
        setIsAllActive(true)
    }

    
    let bookappointment = () => {
        console.info("Entered inside bookappointment()");
        // Enable all tabs when any button is clicked
        setEnableAllTabs(true);
        console.info("Entered inside bookappointment()");
        try {
            console.log("Entered inside bookappointment()");
            dispatch(book_appointment(patientId, userId, chosenDoctorId, chosenTypeOfConsultation, null, selectedTime, selecteddate, temp_appointment_form)).
                then((res) => {
                    console.info("book appoint res",res)
                    if (res?.data?.info) {

                        localStorage.setItem("appointmentId",res?.data?.info)
                    
                        dispatch(show_common_confirm({ message: "Appointment Booked Successfully. \nDo you want to continue?" }))
                        
                    }
                })  
        } catch (error) {
            
        }
    }

    const loadDefaultValues = () => {

        console.log("default...............", appointment_form);

    }
    const onValuesChange = (values) => {
        dispatch({
            type: INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM,
            payload: { ...values }
        })
    }

    const isBookAppointmentDisabled = () => {
        if (appointmentBookStatus) {
            return true
        }
        // If enableAllTabs is true, disable the button (since it should be enabled)
        if (enableAllTabs) {
            return false;
        }
        return !areMandatoryFieldsFilled();
    }


    const loadReportsUploadedToLocalForm = () => {

        let reportTobeLoaded = appointment_form?.reportsUploaded

        if (reportTobeLoaded && reportTobeLoaded.length > 0) {
            dispatch({ type: INTERBRANCH_UPLOAD_REPORTS_UPDATE, payload: reportTobeLoaded });
        }

    }

    const isResume = resumevisible;
const isDisabled = isResume ? (!areMandatoryFieldsFilled() && !enableAllTabs) : false;
const btnType = isResume ? "button" : "submit";

const handleClick = () => {
  // Enable all tabs when any button is clicked
  setEnableAllTabs(true);
  
  if (!isResume) {
    //history.push(`/meetdr/${consultationId}`);
    setButtonClicked("Join");
  } else {
    setButtonClicked("Join");
  }
};

// Handle join consultation from popup
const handleJoinConsultation = () => {
    if (consultationData?.appointmentId) {
        setConsultationPopupVisible(false);
        // history.push(`/meetdr/${consultationData.appointmentId}`);  
        history.push("/meetspoke/"+consultationData?.appointmentId);
    }
};

// Handle cancel consultation popup
const handleCancelConsultation = () => {
    setConsultationPopupVisible(false);
};

    console.log("isDisabled", isDisabled)


    return (
        <div className='choose-doctor-container'>

            <div className="tittle">Doctor Details
                <div className="details-item mandatory">

                    <div className="caption-mandatory"> <span className="red">*</span>  Mandatory</div>

                </div>
            </div>

            <Form
                form={form}
                name="basic"
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 16,
                }}
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                onValuesChange={onValuesChange}
                autoComplete="off"
            >

                <div className="details-item mandatory">

                    <div className="caption">Specialisation<div className="red">*</div></div>
                    <div className="input-item ">

                        <Form.Item

                            name="specialisation"
                            initialValue={appointment_form.specialisation ? appointment_form.specialisation : undefined}
                            rules={[
                                {
                                    required: true,
                                    message: '*Please select specialisation',
                                },
                            ]}
                        >
                            <Dropdown
                                width={300}
                                data={convertSpecialitiesForDropDown(specialities)}
                                onChange={(e) => {
                                    setChosenSpeciality(e);
                                    convertDoctorNamesForDropDown(null);
                                }}
                                placeholder="Select"
                            />

                        </Form.Item>

                    </div>


                </div>

                <div className="details-item mandatory">

                    <div className="caption">Doctor Name <div className="red">*</div></div>
                    <div className="input-item ">
                        <Form.Item
                            name="doctorId"
                            initialValue={appointment_form?.chosendoctorId ? appointment_form.chosendoctorId : undefined}
                            rules={[
                                {
                                    required: true,
                                    message: '*Please select doctor name',
                                },
                            ]}
                        >
                            <Dropdown
                                haveStatus
                                width={300}
                                loading={isDrLoading}
                                data={convertDoctorNamesForDropDown(doctorsList)}
                                onChange={(e) => setChosenDoctorId(e)}


                                placeholder="Select"
                            />


                        </Form.Item>

                    </div>
                    <div className='dorctor-status-info-container' style={{display:"none"}}>

                        <div className="info-item info-item-online">
                            <div className="info-color"></div>
                            <div className="info-caption">Online</div>
                        </div>

                        <div className="info-item info-item-offline">
                            <div className="info-color"></div>
                            <div className="info-caption">Offline</div>
                        </div>

                    </div>

                </div>

                <div className="details-item mandatory">

                    <div className="caption">Type of Consultation <div className="red">*</div></div>
                    <div className="input-item " style={{ textTransform: "capitalize" }}>
                        <Form.Item
                            initialValue={typeOfConsultationBooked ? typeOfConsultationBooked : undefined}
                            name="typeOfConsultation"
                            rules={[
                                {
                                    required: true,
                                    message: '*Please select type of consultation',
                                },
                            ]}
                        >
                            <Dropdown
                                width={300}
                                data={convertTypeOfConsultationForDropDown(typeOfConsultation)}
                                onChange={(e) => setChosenTypeOfConsultation(e)}
                                placeholder="Select"
                            />

                        </Form.Item>
                    </div>


                </div>

                {
                    isScheduled() &&
                    <>
                        <div className="details-item mandatory">

                            <div className="caption">Appointment Date <div className="red">*</div></div>
                            <div className="input-item">

                                <Form.Item
                                    name="date"
                                    
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please select date',
                                        }
                                    ]}
                                >

                                    <DatePicker
                                        value={moment(chosenDate ? chosenDate : "")}
                                        className='input'
                                        style={{ width: "100% !important" }}
                                        format="DD-MM-YYYY"
                                        placeholder="DD-MM-YYYY"
                                        disabledDate={(current) => {
                                            return current < moment().subtract(1, 'day');
                                        }}
                                        // onSelect={getTimeSlots}
                                        onSelect={(e) => { setSelectedDate(convertDateToString(e)); getTimeSlots(e) }}
                                    // defaultValue={moment(new Date())} 
                                    />



                                </Form.Item>


                            </div>


                        </div>

                        <div className="details-item mandatory">

                            <div className="caption">Appointment Time <div className="red">*</div></div>
                            <div className="input-item">

                                <Form.Item
                                    name="time"
                                    initialValue={appointment_form?.chosenTime ? appointment_form.chosenTime : undefined}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please select time',
                                        }
                                    ]}
                                >

                                    <Dropdown
                                        width={300}
                                        data={convertTimesForDropDown(timeSlot)}
                                        onChange={(e) => setSelectedTime(e)}
                                        placeholder="Select"
                                    />

                                </Form.Item>


                            </div>


                        </div></>

                }


                

                <div className="details-item top">

                    <div className="caption">Upload Reports</div>
                    <div className="input-item">
                        <ReportsUploader />
                    </div>


                </div>

                <div className="button-container" onClick={() => setEnableAllTabs(true)}>

                    <button disabled={!areMandatoryFieldsFilled() && !enableAllTabs}
                        className='submt-btn' type='submit' onClick={() => handleSubmit()}>ADD/REVIEW MEDICAL HISTORY</button>

                    {
                        !isScheduled() && !isResume &&
                        <button
                        className="join-btn"
                        type={isResume ? "button" : "submit"}
                        disabled={!areMandatoryFieldsFilled() && !enableAllTabs}
                        onClick={handleClick}
                      >
                        JOIN CONSULTATION
                      </button>
                    }
                    {
                        isScheduled() &&
                        <button type='submit' disabled={isBookAppointmentDisabled()} className='join-btn' onClick={bookappointment}>BOOK APPOINTMENT</button>
                        // :
                        
                    }

                </div>



            </Form>


           
        </div>
    )
}

export default ChooseDoctor
